import React, { FC, memo } from 'react';

import Decimal from 'decimal.js';

import Typography from '@mui/material/Typography';
import theme from '@src/theme';

import { formatBNWithCommas, toBN } from '@utils/formaters.utils';

import { TagType } from '@constants/common/tag.constants';

import useStyles from './styles.module';

const TAG_COLOR: { [key in TagType]?: string } = {
  [TagType.NEW]: theme.primary.p3,
  [TagType.V3]: theme.accent.a1,
};

const TAG_TITLE: { [key in TagType]?: string } = {
  [TagType.NEW]: 'New',
};

interface Props {
  type: TagType;
  value?: Decimal;
}

const Tag: FC<Props> = ({ type, value }) => {
  const color = TAG_COLOR[type];
  const { classes } = useStyles({ color });

  return (
    <Typography variant="caption1" className={classes.tag}>
      {type === TagType.NEW && TAG_TITLE[type]}
      {type === TagType.V3 && `${formatBNWithCommas(value || toBN(0), 2)}%`}
    </Typography>
  );
};

export default memo(Tag);
